<template>
    <form action="/cart/add">
    <div class="form-bundled-product" ref="formbundled">

            <h2 class="product-title product_title" v-html="name"></h2>

            <div v-if="platform === 'woocommerce'" :key="attribute.name" v-for="(attribute, index) in attributes">
                <strong class="name-attribute">{{attribute.name}}: </strong><span class="woo-selected-variation-item-name">{{default_attributes[index].option}}</span>
                <div class="attributesBox" :name="attribute.name" @change="Changeoption" >
                    <div class="optionsBox" :key="option" v-for="option in attribute.options">
                        <input :checked="option == attribute.value_default" class="input_option_attribute" style="display: none" :id="option"  :value="option" :name="attribute.name" type="radio"  />
                        <label class="box_label" :for="option">
                            <div class="option_item">
                                <div v-if="option == 'Wrapped Canvas'" class="option_item_img">
                                    <img width="100%" alt="Wrapped Canvas" src="https://s3.ap-southeast-1.amazonaws.com/canvaspersonalized.com/wp-content/uploads/2021/04/18192308/wrapped-canvas_optimized.png" />
                                </div>
                                <div v-if="option == 'Framed Canvas'" class="option_item_img">
                                    <img width="100%" alt="Framed Canvas" src="https://s3.ap-southeast-1.amazonaws.com/canvaspersonalized.com/wp-content/uploads/2021/04/18192310/framed-canvas_optimized.png" />
                                </div>
                                <div :class="`option_item_title option_item_${attribute.name}`">
                                    {{option}}
                                </div>
                            </div>

                        </label>
                    </div>
                </div>
            </div>

            <div v-if="platform === 'shopify'" :key="attribute.name" v-for="attribute in attributes">
                <strong class="name-attribute">{{attribute.name}}</strong> <br/>
                <select class="select-attribute-shopify" :eposition="attribute.position" :name="attribute.name" @change="Changeoption" >
                    <option :selected="(default_attributes.title).indexOf(option) > 0" :key="option" :value="option" v-for="option in attribute.values">{{option}}</option>
                </select>
            </div>

            <div class="box-messenge-add-to-cart" v-bind:class="{success: addSuccess, error: addError}" v-if="messageStatus">
                {{message}}
            </div>

            <div id="price_html" class="price_html">
                <span class="Price-amount amount-regular-price">
                    <bdi v-if="regular_price != price">
                        <span class="Price-currencySymbol">$</span>
                        <strong v-html="regular_price"></strong>
                    </bdi>
                </span>
                <span class="Price-amount amount">
                    <bdi>
                        <span class="Price-currencySymbol">$</span>
                        <strong v-html="price"></strong>
                    </bdi>
                </span>
            </div>
            <div class="Bundled_Add_to_cart">
                <button @click="OnCloseAddToCart" class="btn cancel-add-to-cart">
                    Cancel
                </button>
                <!-- <input v-if="platform != 'woocommerce'" type="number" min="1" class="form-control Bundled_Add_to_cart_qty" v-model="qty" /> -->
                <button class="btnadd-to-cart" @click="OnAddToCart">
                    <font-awesome-icon icon="spinner" class="fa-spin" v-if="loading" />
                    ADD TO CART
                </button>

            </div>

    </div>
    </form>
</template>

<script>
import jQuery from 'jquery';
import { uploadFromBase64, filterObject, getSignedUrl, prepareCanvasForCapture } from '@/helper/helper';
import { ASSET_URL } from '@/config.js';
export default {
  components: { },
    name: "form-bundled",
    props: {
        originProduct: {
            type: Object,
            default(){
                return null
            } ,
        },
        platform: {
            type: String,
            default(){
                return null
            }
        },
        variants: {
            type: Array,
            default(){
                return {}
            }
        },
        personalized: {
            type: Object,
            default(){
                return {}
            }
        },
        permalink: {
            type: String,
            default(){
                return ''
            }
        },
        artworks: {
          type: Array,
          default(){
              return null
          }
        },
        modalName: {
            type: String,
            default(){
                return null
            }
        }
    },
    data() {
        return {
            regular_price: "",
            price: "",
            default_attributes: {},
            random: '',
            selectedVariant: '',
            name: '',
            qty: 1,
            loading: false,
            message: "Product added to cart successfully!",
            messageStatus: false,
            addSuccess: true,
            addError: false,
        }
    },
    computed: {
        attributes(){
            if(this.platform == "woocommerce"){
                const attributes = this.originProduct.attributes;
                const default_attributes = this.originProduct.default_attributes;
                for(var a=0; a<attributes.length;a++){
                    for(var b=0; b<default_attributes.length;b++){
                        if(attributes[a].name == default_attributes[b].name){
                            attributes[a].value_default = default_attributes[b].option;
                        }
                    }

                }
                return attributes;
            }
            if(this.platform == "shopify"){
                const attributes = this.originProduct.product.options;
                return attributes

            }
        }
    },
    created(){
        if(this.platform == "woocommerce"){
            this.default_attributes = this.originProduct.default_attributes;
            const variants = this.originProduct.variants;
            this.name = this.originProduct.name
            for(var i=0;i<variants.length;i++){
                if(JSON.stringify(variants[i].attributes) === JSON.stringify(this.originProduct.default_attributes)){
                    this.selectedVariant = variants[i].id
                    this.price = Number(variants[i].price).toFixed(2);

                    this.regular_price = Number(variants[i].regular_price).toFixed(2);
                }
            }
        }
        if(this.platform == "shopify"){
            this.name = this.originProduct.product.title;
            const variants = this.originProduct.product.variants;
            this.selectedVariant = variants[0].id
            this.price = Number(variants[0].price).toFixed(2);
            this.regular_price = Number(variants[0].compare_at_price).toFixed(2);
            this.default_attributes = variants[0]
        }

    },
    methods: {
        replaceSpace(string){
            var result = string.replace(/\s+/g, '');
            return result;
        },
        OnCloseAddToCart(e){
            e.preventDefault()
            this.$emit('OnCloseAddToCart', true);
        },
        Changeoption(v){
            if(this.platform == "woocommerce"){
                const name = v.target.name;
                const value = v.target.value;
                const de_attributes = this.default_attributes;
                const variants = this.originProduct.variants;
                for(var a=0; a< de_attributes.length ; a++){
                    if(de_attributes[a].name == name){
                        de_attributes[a].option = value;
                    }
                }
                this.random = Math.floor(Math.random() * (10 - 1 + 1)) + 1;
                this.default_attributes = de_attributes;

                for(var o=0; o<variants.length; o++){
                    if(JSON.stringify(variants[o].attributes) == JSON.stringify(de_attributes) == true){
                        this.selectedVariant = variants[o].id
                        this.price = Number(variants[o].price).toFixed(2);
                        this.regular_price = Number(variants[o].regular_price).toFixed(2);
                    }
                }
            }
            if(this.platform == "shopify"){
                const name = v.target.name;
                const value = v.target.value;
                const variants = this.originProduct.product.variants;
                const selectedVariant = this.selectedVariant;
                const option = `option${v.target.getAttribute('eposition')}`
                for(var key in this.default_attributes){
                    if(key == option){
                        this.default_attributes[key] = v.target.value
                    }
                }
                const default_attr = this.default_attributes;
                for(var a=0; a<variants.length; a++){
                    if(variants[a].option2 && variants[a].option2 != null){
                        if(this.replaceSpace(variants[a].option1) === this.replaceSpace(default_attr.option1) && this.replaceSpace(variants[a].option2) === this.replaceSpace(default_attr.option2)){
                            this.selectedVariant = variants[a].id
                            this.price = Number(variants[a].price).toFixed(2);
                            this.regular_price = Number(variants[a].compare_at_price).toFixed(2);
                        }
                    }else{
                        if(this.replaceSpace(variants[a].option1) === this.replaceSpace(default_attr.option1)){
                            this.selectedVariant = variants[a].id
                            this.price = Number(variants[a].price).toFixed(2);
                            this.regular_price = Number(variants[a].compare_at_price).toFixed(2);
                        }
                    }

                    if(variants[a].option2 && variants[a].option2 != null && variants[a].option3 && variants[a].option3 != null){
                        if(this.replaceSpace(variants[a].option1) === this.replaceSpace(default_attr.option1) && this.replaceSpace(variants[a].option2) === this.replaceSpace(default_attr.option2) && this.replaceSpace(variants[a].option3) === this.replaceSpace(default_attr.option3)){
                            this.selectedVariant = variants[a].id
                            this.price = Number(variants[a].price).toFixed(2);
                            this.regular_price = Number(variants[a].compare_at_price).toFixed(2);
                        }
                    }

                }
            }

        },
        async OnAddToCart(e) {
            e.preventDefault()
            const { platform, variants, selectedVariant } = this

            this.loading = true

            // Chờ font tải xong + vẽ lại canvas trước khi chụp preview gửi khách.
            await prepareCanvasForCapture()

            const image = document.querySelector("#omcustom-product-bundled canvas");

            const icanvas = image.toDataURL()


            var previewImg
            if(icanvas){
                var preview = await uploadFromBase64(icanvas, 'image/png')
                previewImg = preview.key
            }

            var customData = filterObject(this.personalized, [
                'created_at',
                'updated_at',
                'deleted_at',
                'user_id',
                'file_mime',
                'file_name',
                'file_size',
                'source'
            ])

            await Promise.all(
            Object.keys(customData).map(artwork_id => {
                return Promise.all(
                Object.keys(customData[artwork_id]).map(layer_id => {
                    if (
                    customData[artwork_id][layer_id] &&
                    customData[artwork_id][layer_id].base64
                    ) {
                    return new Promise((resolve, reject) => {
                        uploadFromBase64(
                        customData[artwork_id][layer_id].base64,
                        'image/jpeg'
                        )
                        .then(file => {
                            customData[artwork_id][layer_id].key = file.key
                            delete customData[artwork_id][layer_id].base64
                            resolve(1)
                        })
                        .catch(err => reject(err))
                    })
                    } else {
                    return Promise.resolve(1)
                    }
                })
                )
            })
            ).catch(err => err)
            //Generate download printFile URL
            var variant = variants.find(
            v => v.origin_id === selectedVariant.toString()
            )

            var printFiles = await Promise.all(
            Object.keys(customData).map(artwork_id => {
                return getSignedUrl('image/png', 1).then(res => {
                return Promise.resolve({
                    artwork_id,
                    print_area: variant.print_areas.find(
                    printArea => printArea.artwork_id === artwork_id
                    ).name,
                    url: `${ASSET_URL}/${res.key}`, // res.url,
                    key: res.key
                })
                })
            })
            )

            if(this.platform == 'shopify'){
                let formData = {
                    'items': [{
                    'id': this.selectedVariant,
                    'quantity': this.qty,
                    'properties': {
                        '_preview': previewImg,
                        '_print_files': JSON.stringify(printFiles),
                        '_omcustom': JSON.stringify(customData)
                        }
                    }]
                };

                const OnThis = this;

                fetch('/cart/add.js', {
                    method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
                })
                .then(response => {
                    if(response.status == 200){
                        OnThis.$emit("onOK", true)
                    }else{
                        OnThis.message = "Product added to cart failed!"
                        OnThis.messageStatus = true
                        OnThis.addSuccess = false
                        OnThis.addError = true

                        setTimeout(()=>{
                            OnThis.messageStatus = false
                        }, 300)
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
            }

            if(this.platform == "woocommerce"){
                let formData = {
                    "id" : ""+this.selectedVariant + "",
                    "quantity" : ""+this.qty+"",
                    "item_data": {
                        "_preview": ""+previewImg+"",
                        "_print_files": ""+JSON.stringify(printFiles)+ "",
                        "_omcustom": ""+JSON.stringify(customData)+ ""
                    }
                };

                const OnThis = this;

                jQuery.ajax({
                    url: `${this.$store.state.siteURL}/wp-json/cocart/v2/cart/add-item`,
                    method: "POST",
                    data: JSON.stringify(formData),
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    complete: function (response) {
                        if(response.status == 200){
                            OnThis.$emit("onOK", true)
                        }else{
                            OnThis.message = "Product added to cart failed!"
                            OnThis.messageStatus = true
                            OnThis.addSuccess = false
                            OnThis.addError = true

                        setTimeout(()=>{
                            OnThis.messageStatus = false
                        }, 300)
                        }
                    }
                });
            }
            this.loading = false
        }
    }
}
</script>

<style scoped>
    .form-bundled-product{
        padding: 7px;
    }
    .optionsBox > label {
        width: 100%;
    }

    .box_label .option_item{
        border: 1px solid #7f7f7f;
        padding: 8px !important;
        border-radius: 4px !important;
        text-align: center;
        width: 100%;
        cursor: pointer;
        color: #666;
        font-weight: 500;
        font-size: 16px;
    }

    .attributesBox {
        display: flex;
        flex-wrap: wrap;
    }
    .optionsBox {
        margin: 5px 0px;
        width: 33.33%;
        padding: 3px;
    }

    .input_option_attribute[type=radio]:checked + .box_label .option_item {
        background: #3bbf31!important;
        color: #ffffff;
        width: 100%;
        border: 1px solid #17c90a!important;
    }

    strong.name-attribute {
        font-size: 16px;
        font-weight: 600;
        padding-right: 25px;
    }

    .option_item_Size {
        padding: 1px 0px;
        font-size: 15px;
    }

    .option_item_img {
        width: 90px;
        margin: auto;
    }

    span.Price-amount.amount-regular-price {
        text-decoration: line-through #686B5A;
        font-size: 35px;
        margin: 0 5px;
        color: #3bbf31c7;
        font-weight: 300;
    }

    span.Price-amount.amount {
        font-size: 40px;
        margin: 0 5px;
        color: #3bbf31;
    }

    div#price_html {
        display: flex;
        justify-content: center;
        padding: 5px;
        border-top: 2px dotted #71717e;
        margin-top: 15px;
        align-items: flex-end;
    }
    .btnadd-to-cart{
        width: 100%;
        background: #3bbf31;
        border: none;
        outline: none;
        font-size: 18px;
        font-weight: 700;
        color: #ffffff;
        line-height: 0;
        min-height: 37px;
        margin: 0 0;
        height: 45px;
    }

    h2.product-title.product_title {
        padding: 0 !important;
        font-weight: 700;
        color: #373737;
        font-size: 1.7em;
        line-height: 1.3;
        font-family: "Poppins", sans-serif;
        margin: 0 !important;
        margin-bottom: 5px !important;
    }
    .select-attribute-shopify {
        width: 100%;
        height: 45px;
        padding: 0 6px;
        border: 1px solid #aba2a2;
        background: none;
        border-radius: 4px;
        outline: none;
        cursor: pointer;
        margin-top: 5px;
        margin-bottom: 10px;
    }
    .select-attribute-shopify option{
        font-size: 18px;
    }
    .Bundled_Add_to_cart {
        display: flex;
        align-items: center;
    }
    .Bundled_Add_to_cart_qty{
        width: 30%;
        margin-right: 10px;
        min-height: 37px;
        line-height: 0px;
        padding: 6px;
        height: 37px;
        border-radius: 5px;
        box-shadow: none;
    }
    .box-messenge-add-to-cart{
        position: fixed;
        top: 5px;
        right: 5px;
        padding: 9px 19px;
        border-radius: 5px;
        font-weight: 600;
    }

    .success{
        color: #ffffff;
        background: #3bbf31;
    }

    .error{
        color: #ffffff;
        background: #ff5050;
    }

    .cancel-add-to-cart{
        width: 100%;
        background: #777977;
        border: none;
        outline: none;
        font-size: 18px;
        font-weight: 700;
        color: #ffffff;
        line-height: 0;
        min-height: 37px;
        margin: 0 0;
        border-radius: 0px;
        margin-right: 10px;
        display: none;
        height: 45px;
    }

     @media (max-width: 767px) {
         span.Price-amount.amount-regular-price{
             font-size: 35px;
         }
         span.Price-amount.amount{
             font-size: 35px;
         }

         .cancel-add-to-cart{
             display: block;
         }

         .optionsBox {
            width: 46%;
            margin: 5px;
        }

        .box_label .option_item{
            width: 100% !important;
        }
     }
     .woo-selected-variation-item-name{
        color: red;
        line-height: 1.3;
        font-size: 15px;
     }
</style>



// WEBPACK FOOTER //
// src/components/BundledProduct/FormBundled/FormBundled.vue